var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm"},[_c('div',{staticClass:"confirm__content"},[(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_c('p',[_vm._v("Le formulaire a bien été envoyé !")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }